import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '@modules/auth/services';
import { Router } from '@angular/router';

@Component({
    selector: 'cwr-unauthorized',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './unauthorized.component.html',
    styleUrls: ['unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
    constructor(private _authService: AuthService, private _router: Router) {}

    ngOnInit() {}

    logout() {
        // this._authService.logout();
        this._router.navigate(['/'], { replaceUrl: true });

    }
}
